import React from "react";
import { cn } from "@ui";
import type { LucideIcon } from "lucide-react";

interface SidebarNavItemProps {
  icon?: LucideIcon;
  label: string;
  sublabel?: string;
  isActive?: boolean;
  onClick: () => void;
}

export function SidebarNavItem({
  icon: Icon,
  label,
  sublabel,
  isActive = false,
  onClick,
}: SidebarNavItemProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "w-full px-4 py-3 text-left flex items-start gap-3 transition-colors",
        isActive
          ? "bg-default-50 border-r-2 border-default-600"
          : "hover:bg-default-50"
      )}
    >
      {Icon && (
        <Icon
          className={cn(
            "w-4 h-4 flex-shrink-0 mt-0.5",
            isActive ? "text-default-600" : "text-default-400"
          )}
        />
      )}
      <div className="min-w-0 flex-1">
        <div
          className={cn(
            "text-sm font-medium truncate",
            isActive ? "text-default-900" : "text-default-900"
          )}
        >
          {label}
        </div>
        {sublabel && (
          <div className="text-xs text-default-500 mt-0.5">{sublabel}</div>
        )}
      </div>
    </button>
  );
}
